const UserInfo = () => import('@pages/main/user/Info')

export const info = [
  {
    path: '/user/info',
    name: 'UserInfo',
    component: UserInfo,
    meta: {auth: true}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/info.route.js